<template>
  <div class="DUse">
    <div class="inner_center">
      <h2 class="headline">3D设计如何应用</h2>
      <div class="subhead">打破传统，高效吸睛的设计新体验</div>

      <div class="classify-list">
        <div
          v-for="(vo,idx) in THREE_D.USE.CLASSIFY_LIST"
          :key="vo.id"
          :class="{ 'ON' : idx === classifyIdx }"
          class="classify-item"
          @click="toggleClassify(vo,idx)"
          @mouseover="toggleClassify(vo,idx)"
        >
          <i class="classify-tag"/>
          <div class="classify-label">{{ vo.label }}</div>
        </div>
      </div>

      <div class="pics">
        <div
          v-for="(vo,idx) in THREE_D.USE.CLASSIFY_LIST[classifyIdx].pics"
          :key="idx"
          class="pic-item"
        >
          <img
            :src="vo">
          <i class="icon_badge"/>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {THREE_D} from "@/constant/3d/3D";

export default {
  name: "DUse",
  data() {
    return {
      THREE_D,
      classifyIdx: 0
    }
  },
  methods: {
    toggleClassify(vo, idx) {
      this.classifyIdx = idx;
    }
  }
}
</script>

<style lang="scss" scoped>
.DUse {
  margin-bottom: 111px;
  .inner_center {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .headline {
    font-size: 44px;
    font-weight: bold;
    color: #21222E;
    line-height: 59px;
    letter-spacing: 1px;
    text-align: center;
    margin: 72px 0 12px;
  }

  .subhead {
    font-size: 18px;
    color: #373842;
    line-height: 24px;
    letter-spacing: 1px;
    text-align: center;
  }

  .classify-list {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;

    .classify-item {
      width: 142px;
      height: 40px;
      border-radius: 4px;
      margin-right: 30px;
      @include LayoutFlex(1);
      font-size: 15px;
      color: #21222E;
      letter-spacing: 1px;
      position: relative;
      cursor: pointer;

      .classify-tag {
        @include BgImage(142px, 40px, '3d/use-btn.png');
        @include Position(1, 5, 0, 0);
      }

      .classify-label {
        position: relative;
        z-index: 2;
      }

      &:last-child {
        margin-right: 0;
      }

      &.ON {
        .classify-label {
          font-weight: bold;
        }

        .classify-tag {
          @include BgImage(142px, 66px, '3d/use-btn@active.png');
        }
      }
    }
  }

  .pics {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    //justify-content: space-around;
    //justify-content: space-between;
    margin-top: 69px;

    .pic-item {
      position: relative;
      margin-right: 119px;
      //margin-right: 120px;

      &:last-child {
        margin-right: 0;
      }

      img {
        display: inline-block;
        width: 540px;
        height: 520px;
        background: #FFFFFF;
        border-radius: 40px 0px 40px 40px;
      }

      .icon_badge {
        @include BgImage(197px, 36px, '3d/use/use-case-badge.png');
        @include Position(1, 2, -7px, -18px);
      }
    }

  }
}

</style>
